import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import type { CalendarEventType, CancelledAppointmentCalendarEvent } from '../../../types';

interface Props {
  event: CancelledAppointmentCalendarEvent;
}
export const CancelledAppointmentEvent = ({ event }: Props) => {
  return (
    <div data-event-type={'cancelledAppointment' satisfies CalendarEventType} css={containerStyle}>
      {event.eventType}
    </div>
  );
};

const containerStyle = css({
  padding: theme.spacing(0.5),
  borderRadius: theme.borderRadius.small,
  boxShadow: theme.shadows.light,
  // TODO: change color
  background: 'rgba(255, 184, 179, 0.2)',
  border: '1.5px dashed #DD3131',
});
